import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVideo2"><Path d="M17 19.5H2V4.5H17V19.5Z" fill="currentColor"/><Path d="M22.5 18.1182L18.5 16.1182V7.88184L22.5 5.88184V18.1182Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideo2;
